import { useCallback, useEffect, useState } from 'react';

export function useCookieConsent() {
  const [cookieConsent, setCookieConsentState] = useState<boolean>();

  useEffect(() => {
    if (cookieConsent === undefined) {
      void cookieStore.get('cookieConsent').then((cookie) => {
        if (cookie?.value === undefined) {
          return;
        }

        setCookieConsentState(cookie?.value === 'true');
      });
    }
  }, [cookieConsent]);

  const setCookieConsent = useCallback(
    (value: boolean) => {
      void cookieStore.set('cookieConsent', value.toString()).then(() => {
        setCookieConsentState(true);
      });
    },
    [setCookieConsentState],
  );

  return [cookieConsent, setCookieConsent] as const;
}
